import { render, staticRenderFns } from "./FormPeriodicidade.vue?vue&type=template&id=c2453f60&scoped=true"
import script from "./FormPeriodicidade.vue?vue&type=script&lang=js"
export * from "./FormPeriodicidade.vue?vue&type=script&lang=js"
import style0 from "./FormPeriodicidade.vue?vue&type=style&index=0&id=c2453f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2453f60",
  null
  
)

export default component.exports